import { StatelessComponent } from 'react'
import * as styles from 'styles/pages/Security.css'
import { ExternalPageHeading } from 'components/atoms/Text'
import Anchor from 'components/atoms/navigation/Anchor'
import ExternalLayout from 'components/features/external/ExternalLayout/ExternalLayout'
import { TwoColumnRowLayout } from 'components/layouts/Layouts'
import { PageMeta } from 'components/features/pfm/PageMeta/PageMeta'

const Security: StatelessComponent = () => {

  const summary = (
    <article className={ styles.summary }>
      <ExternalPageHeading>
        Protecting Your Information is Our Highest Priority
      </ExternalPageHeading>
      <p className={ styles.summaryText }>
        We value the trust you place in us to help you make smarter
        financial decisions and it is our highest priority to safeguard
        your personal information using state-of-the-art technology
        and security standards.
      </p>
    </article>
  )

  const encryption = (
    <article>
      <h2 className={ styles.blockTitle }>Industry-Leading Encryption</h2>
      <p className={ styles.blockText }>
        Status encrypts your information using 256-bit SSL encryption
        while it is in-transit and at-rest. We also use dual-level field encryption
        in our database to further protect your sensitive personal information.
      </p>
    </article>
  )

  const protocol = (
    <article>
      <h2 className={ styles.blockTitle }>Most Secure Server Protocol</h2>
      <p className={ styles.blockText }>
        Status only uses TLS 1.2, the most recent communications security protocol.
        Less secure protocols such as TLS 1.1, TLS 1.0, SSLv3, or RC are not allowed.
      </p>
    </article>
  )

  const access = (
    <article>
      <h2 className={ styles.blockTitle }>Read-Only Access</h2>
      <p className={ styles.blockText }>
        Status only has read access to your linked financial accounts.
        So the money in your accounts will be safe even if your Status account is ever compromised.
      </p>
    </article>
  )

  const authentication = (
    <article>
      <h2 className={ styles.blockTitle }>Multi-Factor Authentication</h2>
      <p className={ styles.blockText }>
        Status requires you to verify logins from new devices via email
        and tracks every login to your account. You will also get alerts
        when any account information is modified.
      </p>
    </article>
  )

  const controls = (
    <article>
      <h2 className={ styles.blockTitle }>Strict Access Controls</h2>
      <p className={ styles.blockText }>
        No one at Status has access to your account and bank credentials,
        and our servers are protected 24/7.
      </p>
    </article>
  )

  const partners = (
    <article>
      <h2 className={ styles.blockTitle }>Best-in-Class Security Partners</h2>
      <p className={ styles.blockText }>
        Status has partnered with the leading security companies
        to provide multi-layered data protection.
      </p>
    </article>
  )

  return (
    <Anchor placement='security'>
      <PageMeta
        title='Advanced Security'
        description='Industry-Leading Encryption | Multi-Factor Authentication'
      />
      <ExternalLayout
        type='common'
      >
        <div className={ styles.security }>
          { summary }

          <TwoColumnRowLayout left={ encryption } right={ protocol } />
          <TwoColumnRowLayout left={ access } right={ authentication } />
          <TwoColumnRowLayout left={ controls } right={ partners } />

          <div className={ styles.partnerLogos }>
            <img
              className={ styles.partnerLogo }
              src='/images/partner-logos/alert-logic.png'
              alt='Alert Logic'
            />
            <img
              className={ styles.partnerLogo }
              src='/images/partner-logos/rb-security.png'
              alt='RiskBased Security'
            />
            <img
              className={ styles.partnerLogo }
              src='/images/partner-logos/bit-defender.png'
              alt='Bitdefender'
            />
          </div>
        </div>
      </ExternalLayout>
    </Anchor>
  )
}

export default Security
